(function ($) {
    function AccountMenu() {
        this.menu = $('.dashboard-wrap .sidebar-wrapper .sidebar-content');

        this.init();
    }

    AccountMenu.prototype = {
        init: function () {
            let self = this;

            self.menu
                .find('.sidebar-dropdown > a')
                .click(function () {
                    self.menu
                        .find('.sidebar-submenu')
                        .slideUp(200);

                    if ($(this).parent().hasClass("active")) {
                        self.menu
                            .find('.sidebar-dropdown')
                            .removeClass('active');

                        $(this).parent().removeClass("active");
                    } else {
                        self.menu
                            .find('.sidebar-dropdown')
                            .removeClass('active');

                        $(this).next(".sidebar-submenu").slideDown(200);
                        $(this).parent().addClass("active");
                    }
                });
        }
    }

    $(document).ready(function () {
        new AccountMenu();
    });
}) (jQuery)
